import { genLanguageOption } from "../helpers/option";

const languaages = ["english", "china", "japanese", "korea", "india", "russia"];
export const options = genLanguageOption(languaages);
